import { render, staticRenderFns } from "./Evaluationgame.vue?vue&type=template&id=ceac7394&scoped=true"
import script from "./Evaluationgame.vue?vue&type=script&lang=js"
export * from "./Evaluationgame.vue?vue&type=script&lang=js"
import style0 from "./Evaluationgame.vue?vue&type=style&index=0&id=ceac7394&prod&scoped=true&lang=css"
import style1 from "./Evaluationgame.vue?vue&type=style&index=1&id=ceac7394&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceac7394",
  null
  
)

export default component.exports